import React from "react";
import { CtaButton } from "../CtaButton";
import { Icon } from "../Icon";
import { SectionHeading } from "../SectionHeading";
import { purposes } from "../../data/content";
export function Purposes() {
  return <section className="w-full bg-cream px-4 py-16 sm:py-20" data-id="element-272" data-mp="3lvqccinsk50e">
      <div className="mx-auto max-w-5xl" data-id="element-273" data-mp="3h3yinz9c9j61">
        <SectionHeading title={<>What the Protocol Vault Is <em className="text-forest" data-id="element-275" data-mp="3uv3f6shetvc5">Designed to Help You Do</em></>} intro="Here are the practical purposes behind the system." data-id="element-274" data-mp="3h36p0tzaxvie" />
        <ul className="mt-10 grid gap-x-10 gap-y-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-276" data-mp="3qt8bxifx57vq">
          {purposes.map(p => <li key={p.title} data-id="element-277" data-mp="8m2f9995iuoh">
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-forest text-white" data-id="element-278" data-mp="3pbrdzr3uusi">
                <Icon name={p.icon} className="h-6 w-6" data-id="element-279" data-mp="2af05qyfghb69" />
              </span>
              <h3 className="mt-4 text-[18px] font-bold leading-snug text-ink" data-id="element-280" data-mp="25gf3yukk2jfp">{p.title}</h3>
              <p className="mt-1.5 text-[16px] leading-relaxed text-muted" data-id="element-281" data-mp="1qxppf9u9ujd7">{p.text}</p>
            </li>)}
        </ul>
        <p className="mx-auto mt-10 max-w-2xl text-center text-[13px] leading-relaxed text-muted" data-id="element-282" data-mp="1vwamx1i52oxy">
          The Protocol Vault is designed to support educational organization and learning. It does not replace comprehensive professional training, scientific evaluation, or appropriate medical care.
        </p>
        <div className="mt-8" data-id="element-283" data-mp="29n5r40hp0hv7">
          <CtaButton label="I want a ready-made learning system" data-id="element-284" data-mp="29nz2xfvidxk7" />
        </div>
      </div>
    </section>;
}